/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import FeedService from 'scripts/services/base-feed-service';
import appContext from 'scripts/app-context';

const isNotFoundError = (error) => {
    const description = 'The data for year';
    const reason = 'does not exist';
    const errorMessage = error.statusText;
    return (
        errorMessage.indexOf(description) > -1 &&
        errorMessage.indexOf(reason) > -1
    );
};

export default can.Construct.extend(
    {},
    {
        init({ feedUrl, fromCache, autoUpdate, headers }) {
            this.feedService = new FeedService({
                feedUrl,
                fromCache,
                autoUpdate,
                headers,
            });
        },

        onFetching(callback) {
            this.feedService.on('fetching', (event, value) =>
                callback(event, value, this.identifier),
            );
            return this;
        },

        onData(callback) {
            const dataCallback = (ev, data) => {
                if (this.identifier === 'meta') {
                    this._triggerUpdateYears(data.years, data.legend);
                    return;
                } else {
                    callback(ev, data);
                }
            };
            this.feedService.on('data', dataCallback);
            return this;
        },

        onError(callback) {
            const errorCallback = (ev, error) => {
                if (this.identifier === 'meta') {
                    console.warn('Cannot fetch years...', error);
                } else if (isNotFoundError(error)) {
                    const year = this.identifier;
                    this._triggerRemoveYear(year);
                } else {
                    callback(ev, error);
                }
            };

            this.feedService.on('error', errorCallback);
            return this;
        },

        fetch(identifier, fetchingParams) {
            this.identifier = identifier;
            this.feedService.fetch(fetchingParams);
        },

        _triggerUpdateYears(years, legend) {
            const injectYearsEvent =
                'history-experience-scoring-and-stats-years-ready';
            appContext.model.dispatch(injectYearsEvent, [years, legend]);
        },

        _triggerRemoveYear(year) {
            const removeYearEvent =
                'history-experience-scoring-and-stats-year-remove';
            appContext.model.dispatch(removeYearEvent, [year]);
        },
    },
);
